import { REQUEST_ACTIONS } from './types';

export function fetchActions() {
  return {
    type: REQUEST_ACTIONS
  };
}



// WEBPACK FOOTER //
// ./src/actions/actions.js